<template>
  <div class="content-wrapper">
    <div class="tool-bar-box">
      <div class="filter-box">
        <div class="left">
          <div class="filter-item-box">
            <span>状态</span>
            <div class="filter-item-value-box">
              <div
                class="filter-item"
                :class="{ active: form.status === 'all' }"
                @click="handleFilter('status', 'all')"
              >
                <span>全部</span>
                <span>{{ count.all }}</span>
              </div>
              <div
                class="filter-item"
                :class="{ active: form.status === 'pending' }"
                @click="handleFilter('status', 'pending')"
              >
                <span>待开票</span>
                <span>{{ count.pending }}</span>
              </div>
              <div
                class="filter-item"
                :class="{ active: form.status === 'invoiced' }"
                @click="handleFilter('status', 'invoiced')"
              >
                <span>已开票</span>
                <span>{{ count.invoiced }}</span>
              </div>
              <div
                class="filter-item"
                :class="{ active: form.status === 'rejected' }"
                @click="handleFilter('status', 'rejected')"
              >
                <span>已驳回</span>
                <span>{{ count.rejected }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <span class="select-desc">已选{{ checkedList.length }}条</span>
          <div class="batch-btn" @click="onBatchExport">
          <img class="batch-btn-icon" src="https://img.hongli.xingjuju.com/yichuanghub/default/20260902/3513164fa95b36398cd61027b6046303.png" alt="">
            批量导出
          </div>
        </div>
      </div>
    </div>
    <div class="table-box">
      <table>
        <colgroup>
          <col style="width: 50px" />
          <col style="width: 160px" />
          <col style="width: 180px" />
          <col style="width: 100px" />
          <col style="width: 160px" />
          <col style="width: 120px" />
          <col style="width: 150px" />
          <col style="width: 120px" />
          <col style="width: 80px" />
          <col style="width: 140px" />
        </colgroup>
        <thead>
          <tr>
            <th>
              <div class="col-check">
                <Checkbox
                  :indeterminate="checkIndeterminate"
                  :value="checkAll"
                  @on-change="onCheckAll"
                ></Checkbox>
              </div>
            </th>
            <th>订单编号</th>
            <th>买家信息</th>
            <th>开票金额</th>
            <th>发票抬头</th>
            <th>发票类型</th>
            <th>买家邮箱</th>
            <th>申请时间</th>
            <th>状态</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in list" :key="item.id">
            <td>
              <div class="col-check">
                <Checkbox
                  :value="checkedList.includes(item.id)"
                  :label="item.id"
                  @on-change="(val) => onSingleCheck(val, item.id)"
                ></Checkbox>
              </div>
            </td>
            <td>
              <div class="col-text">{{ item.order_no }}</div>
            </td>
            <td>
              <div class="col-user">
                <div class="name">{{ item.nickname }}</div>
                <div class="phone">{{ item.mobile }}</div>
              </div>
            </td>
            <td>
              <div class="col-text">¥{{ item.pay_amount }}</div>
            </td>
            <td>
              <div class="col-text">{{ item.title }}</div>
            </td>
            <td>
              <div class="col-text">{{ taxTypeText(item.tax_type) }}</div>
            </td>
            <td>
              <div class="col-text">{{ item.send_mail }}</div>
            </td>
            <td>
              <div class="col-text">{{ item.create_time }}</div>
            </td>
            <td>
              <div class="col-status">
                <span :class="getStatusClass(item.status)">{{ getStatusText(item.status) }}</span>
              </div>
            </td>
            <td>
              <div class="col-action">
                <template v-if="item.status === 1 || item.status === 3">
                  <span class="action-link" @click="showDetail(item)">审核开票</span>
                  <span class="action-link gray" @click="showReject(item)">驳回</span>
                </template>
                <template v-if="item.status === 2">
                  <span class="action-link" @click="showDetail(item)">查看详情</span>
                  <span class="action-link" @click="onDownload(item)">下载</span>
                </template>
                <template v-if="item.status === 4">
                  <span class="action-link gray" @click="showDetail(item)">查看详情</span>
                </template>
              </div>
            </td>
          </tr>
          <tr v-if="!list.length">
            <td colspan="10" class="empty-tip">暂无数据</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="page-container">
      <Page
        :total="total"
        :current="form.page"
        :page-size="form.limit"
        size="small"
        prev-text="上一页"
        next-text="下一页"
        @on-change="onPageChange"
      ></Page>
    </div>

    <!-- 开票申请详情（待开票/已开票/已驳回） -->
    <InvoiceDetailModal
      :visible.sync="detailModalVisible"
      :data="currDetail"
      @confirm="onDetailConfirm"
      @reject="onDetailReject"
      @download="onDownload"
    />
    <!-- 驳回开票 -->
    <InvoiceRejectModal
      :visible.sync="rejectModalVisible"
      :data="currDetail"
      @confirm="onRejectConfirm"
      @cancel="rejectModalVisible = false"
    />
  </div>
</template>

<script>
import {
  InvoiceHandleList,
  InvoiceHandleConfirm,
  InvoiceHandleReject,
  InvoiceHandleDownload,
} from '@/api/index'
import util from '@/utils/util'
import InvoiceDetailModal from './InvoiceDetailModal.vue'
import InvoiceRejectModal from './InvoiceRejectModal.vue'

export default {
  name: 'InvoiceHandleTab',
  components: {
    InvoiceDetailModal,
    InvoiceRejectModal,
  },
  props: {
    // tab 栏右侧搜索关键字，变化时触发列表搜索
    keyword: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 查询表单
      form: {
        page: 1,
        limit: 10,
        status: 'all',
        keyword: this.keyword || '',
      },
      total: 0,
      count: {
        all: 0,
        pending: 0,
        invoiced: 0,
        rejected: 0,
      },
      list: [],
      loading: false,
      checkedList: [],
      checkAll: false,
      checkIndeterminate: false,

      // 弹窗
      detailModalVisible: false,
      rejectModalVisible: false,
      currDetail: {},
    }
  },
  watch: {
    // 父级 tab 栏搜索框回车/点击后触发
    keyword(val) {
      this.form.keyword = val
      this.onSearch()
    },
  },
  created() {
    this.fetchList()
  },
  methods: {
    // ===== 状态/类型映射（status：1-待开票 2-已开票 4-已驳回；tax_type：0-普票 1-专票） =====
    getStatusClass(status) {
      const map = {
        1: 'warn',
        3: 'warn',
        2: 'success',
        4: 'gray',
      }
      return map[status] || ''
    },
    getStatusText(status) {
      const map = {
        1: '待开票',
        3: '重新开票',
        2: '已开票',
        4: '已驳回',
      }
      return map[status] || status
    },
    taxTypeText(taxType) {
      return taxType == 1 ? '电子专用发票' : '电子普通发票'
    },

    // ===== 列表加载 =====
    async fetchList() {
      this.loading = true
      try {
        const res = await InvoiceHandleList(this.form)
        const data = res.data || {}
        this.list = data.list || []
        this.total = data.total || 0
        this.count = Object.assign(
          { all: 0, pending: 0, invoiced: 0, rejected: 0 },
          data.count || {}
        )
        this.checkedList = []
        this.onCheckChange()
      } catch (e) {
        this.$Message.error((e && e.msg) || '获取列表失败')
      } finally {
        this.loading = false
      }
    },
    onSearch() {
      this.form.page = 1
      this.fetchList()
    },
    handleFilter(type, value) {
      this.form[type] = value
      this.form.page = 1
      this.fetchList()
    },
    onPageChange(page) {
      this.form.page = page
      this.fetchList()
    },

    // ===== 勾选 =====
    onSingleCheck(checked, id) {
      if (checked) {
        if (!this.checkedList.includes(id)) {
          this.checkedList.push(id)
        }
      } else {
        const index = this.checkedList.indexOf(id)
        if (index > -1) {
          this.checkedList.splice(index, 1)
        }
      }
      this.onCheckChange()
    },
    onCheckChange() {
      if (this.checkedList.length === 0) {
        this.checkIndeterminate = false
        this.checkAll = false
      } else if (this.checkedList.length === this.list.length) {
        this.checkIndeterminate = false
        this.checkAll = true
      } else {
        this.checkIndeterminate = true
        this.checkAll = false
      }
    },
    onCheckAll() {
      if (this.checkIndeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.checkIndeterminate = false
      if (this.checkAll) {
        this.checkedList = this.list.map((item) => item.id)
      } else {
        this.checkedList = []
      }
    },
    async onBatchExport() {
      const params = {
        status: this.form.status,
        keyword: this.form.keyword,
      }
      // 选中则按选中导出，不选中则按当前筛选条件导出
      if (this.checkedList.length) {
        params.ids = this.checkedList
      }
      try {
        await util.downloadExcel('/shop/invoice/handle-export', params, this.$store.state.token, '开票处理')
        this.$Message.success('导出成功')
      } catch (e) {
        this.$Message.error((e && e.message) || '导出失败')
      }
    },

    // ===== 弹窗交互 =====
    showDetail(item) {
      this.currDetail = { ...item }
      this.detailModalVisible = true
    },
    showReject(item) {
      this.currDetail = { ...item }
      this.rejectModalVisible = true
    },
    onDetailClose() {
      this.detailModalVisible = false
      this.currDetail = {}
    },
    async onDetailConfirm({ tax_file }) {
      try {
        await InvoiceHandleConfirm({
          id: this.currDetail.id,
          tax_file,
          send_mail: this.currDetail.send_mail,
        })
        this.detailModalVisible = false
        this.$Message.success('开票成功，已发送至买家邮箱')
        this.currDetail = {}
        this.fetchList()
      } catch (e) {
        this.$Message.error((e && e.msg) || '操作失败')
      }
    },
    onDetailReject(item) {
      this.detailModalVisible = false
      this.currDetail = { ...item }
      this.rejectModalVisible = true
    },
    async onRejectConfirm(data) {
      try {
        await InvoiceHandleReject({
          id: data.id,
          reject_reason: data.reject_reason,
          reject_remark: data.reject_remark,
        })
        this.$Message.success('驳回成功')
        this.rejectModalVisible = false
        this.currDetail = {}
        this.fetchList()
      } catch (e) {
        this.$Message.error((e && e.msg) || '操作失败')
      }
    },
    // 下载电子发票（参考 PlatformInvoiceTab.onDownloadInvoice：统一下载文件名，避免浏览器使用随机/链接名）
    async onDownload(item) {
      try {
        const res = await InvoiceHandleDownload({ id: item.id })
        const url = (res.data && res.data.url) || ''
        if (url) {
          const base = url.split('?')[0].split('/').pop() || 'invoice.pdf'
          util.downloadFile(url, '发票_' + (item.order_no || item.id) + '_' + base)
        } else {
          this.$Message.warning('暂无发票文件')
        }
      } catch (e) {
        this.$Message.error((e && e.msg) || '下载失败')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import './invoice-common.scss';

.empty-tip {
  text-align: center;
  color: #999999;
  padding: 40px 0;
}
</style>
